<template>
  <div class="hrt-component">
    <!-- Icon - Using direct shield SVG as requested -->
    <img 
      src="/img/hrt-shield.svg" 
      alt="OnePass Authentication" 
      class="hrt-icon" 
    />

    <!-- Session Ended Text -->
    <div class="hrt-content" v-html="renderedDeniedText" />

    <!-- Try Again Button -->
    <button @click="$emit('retry')" class="hrt-button">Try Again</button>

    <!-- Footer Text -->
    <div class="hrt-disclaimer" v-html="renderedFooterText" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import MarkdownIt from "markdown-it";
import type { IconType } from "./types";

const props = defineProps<{
  icon: IconType;
  textDenied: string;
  textFooter: string;
}>();

defineEmits<{
  (e: "retry"): void;
}>();

const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
});

const renderedDeniedText = computed(() => {
  return md.render(props.textDenied);
});

const renderedFooterText = computed(() => {
  return md.render(props.textFooter);
});
</script>

<style lang="scss" scoped>
@use "./styles/hrt.scss";
</style>
